import React, { useState } from "react";
import  styles from  './checkbox-dialog.module.scss'; // import CSS file with animation styles
import IconFilter from '../../common/icon/icon-filter';


const  CheckboxDialog= ({onClick, groupOptions}) => {
  const groupOptionList = groupOptions.map(i => i.value);
  
  const [isModalOn, setIsModalOn] = useState(false);
  const [filterGroupOption, setFilterGroupOption] = useState(groupOptionList);
  
  const handleSubmitForm = () =>{
    onClick(filterGroupOption);
  }
  
  return (
    <div className='checkboxDialog'>
      <button className={`${styles.groupButton} ${styles.groupFilterButton} ${isModalOn? styles.hideGroupButton: ''}`} onClick={() => setIsModalOn(!isModalOn)} >
        <span>Group Filter</span>
        <IconFilter/>
      </button>
      <div className="dialogContainer">
        <dialog className={styles.dialog} open={isModalOn} onClose={() => setIsModalOn(false)}>
          {/* <button onClick={() => setIsModalOn(false)} autoFocus>Close</button> */}
          <form method="dialog" className="w-100">
            <fieldset>
                <div className={styles.dialogList}>
                  <label className={`${styles.checkLabel} ${styles.groupButtonTitle}`}>Group filter</label>
                  <label className={styles.checkLabel}>
                    <input type="checkbox"
                      className={styles.checkbox}
                      checked={filterGroupOption.length === groupOptions.length}
                      indeterminate={
                        (filterGroupOption.length > 0 && filterGroupOption.length < groupOptions.length)
                        ? "true" : undefined
                      }
                      onChange={(event) => {
                        if (event.target.checked) {
                          setFilterGroupOption(groupOptionList);
                        } else {
                          setFilterGroupOption([]);
                        }
                      }}
                    />
                    ALL
                  </label>
      
                  {groupOptions.map((item) => (
                    <label className={`item ${styles.checkLabel}`} key={item.value}>
                      <input type="checkbox"
                        className={styles.checkbox}
                        checked={filterGroupOption.includes(item.value)}
                        onChange={() => {
                          if (filterGroupOption.includes(item.value)) {
                            setFilterGroupOption((s) => s.filter((i) => i !== item.value));
                          } else {
                            setFilterGroupOption((s) => [...s, item.value]);
                          }
                        }}
                      />
                      {item.label}
                    </label>
                  ))}
      
                </div>
              <div>
                <button type="submit" className={`${styles.groupButton} ${styles.submitButton}`} onClick={handleSubmitForm}>
                  <span>Filter</span>
                  <IconFilter/>
                </button>
              </div>
            </fieldset>
          </form>
        </dialog>
      </div>
    </div>
    // <></>
  )

}

export default CheckboxDialog;
